// Types
export type {
  EulerIndexerELend,
  EulerIndexerELendsResponse,
  EulerIndexerExposure,
  EulerIndexerIntrinsicApy,
  EulerIndexerRewardsMetadata,
  EulerIndexerEntity,
  EulerIndexerProduct,
  NormalizedELendInfo,
  ELendCacheEntry,
  ELendDataSourcePriority,
  ELendFetcherConfig,
} from './types'

// Request body and settings types for v2 vault list
export type { VaultListRequestBody, PerspectiveSettings } from './elendsQuery'

// ELend Query (Euler Indexer v2)
export {
  eulerELendsQueryKey,
  eulerELendsQueryOptions,
  useEulerIndexerELends,
  useEulerIndexerDefaultELends,
  useEulerIndexerGovernedELends,
  useEulerIndexerELend,
  usePrefetchEulerELends,
  getELendFromCache,
  setELendInCache,
  // Perspective addresses
  PERSPECTIVE_ADDRESSES,
  DEFAULT_ENABLED_PERSPECTIVES,
  DEFAULT_DISABLED_PERSPECTIVES,
} from './elendsQuery'

// Onchain ELend Fetcher (Fallback)
export { fetchELendOnchain, fetchELendsOnchain } from './onchainELendFetcher'

// Combined Hook (Indexer-first, Onchain-fallback)
export {
  useELendInfo,
  useELendsInfo,
  getELendFromMap,
  useELendAddresses,
  useELendsList,
  useDefaultELendsList,
  useGovernedELendsList,
} from './useELendInfo'
